// extracted by mini-css-extract-plugin
module.exports = {"component":"ZoneLeaderEffects_component__xLjgT","leader-opponent":"ZoneLeaderEffects_leader-opponent__SP6TI","leader-player":"ZoneLeaderEffects_leader-player__gcIl2"};